<template>
  <footer
    class="footer noprint"
    role="contentinfo"
  >
    <img
      :src="props$$.img"
      alt="Gobierno de España. Ministerio de Transportes y Movilidad Sostenible"
      class="footer__img"
    />
    <nav
      class="footer__menu-container"
      aria-label="Enlaces de pie de página"
    >
      <ul class="footer__menu-container__menu">
        <li
          v-for="item in menuRef"
          :key="item.name"
          class="footer__menu-container__menu__item"
        >
          <a
            :href="item.src"
            :accesskey="item.accesskey"
            class="footer__menu-container__menu__item__link"
            tabindex="0"
          >
            {{ item.name }}
          </a>
        </li>
      </ul>
    </nav>
    <span
      class="footer__text"
      aria-label="Versión de la aplicación"
      title="Versión de la aplicación"
    >
      {{ versionRef }}
    </span>
  </footer>
</template>

<script setup>
import {
  onMounted,
  shallowRef,
  ref,
} from 'vue';

import {version} from './version.js';

// #region Props, Emits
const legalNoticeUrl = STTEDRA_URL_LEGAL_NOTICE;
const contactUrl = STTEDRA_URL_CONTACT;
const accessibilityUrl = STTEDRA_URL_ACCESSIBILITY;
const dataProtectionUrl = STTEDRA_URL_DATA_PROTECTION;

const props$$ = defineProps({
  img: {
    type: String,
    default: require('@/assets/images/footer-ministerio.svg'),
  },
  menu: {
    type: Array,
    default: () => [],
  },
});
// #endregion

// #region Params, Ref, Reactives, Computed
const versionRef = shallowRef(`v${version}` || 'v1.0.4');
const menuRef = ref([{
  name: 'Aviso legal',
  src: legalNoticeUrl,
  accesskey: '6',
},
{
  name: 'Contacto',
  src: contactUrl,
  accesskey: '5',
},
{
  name: 'Accesibilidad',
  src: accessibilityUrl,
  accesskey: '0',
},
{
  name: 'Protección de datos',
  src: dataProtectionUrl,
}]);
// #endregion

// #region Funtions


// #endregion

// #region Effects, Hooks
onMounted(async () => {
  // await readFileVersion();
});
// #endregion
</script>

<style lang="scss" scoped>
@use '@/styles/vars' as *;
@use '@/styles/breakpoints' as *;

.footer{
  @include media("<=phone") {
    padding: $brand__boxspace--medium ($brand__boxspace--medium * 1) $brand__boxspace--medium
    ($brand__boxspace--medium * 1.5);
  }

  @include media(">phone") {
    padding: $brand__boxspace--medium ($brand__boxspace--medium * 2) $brand__boxspace--medium
    ($brand__boxspace--medium * 2.5);
  }

  @include media(">phone", "<=tablet") {
    padding: $brand__boxspace--medium ($brand__boxspace--medium * 3) $brand__boxspace--medium
    ($brand__boxspace--medium * 3.5);
  }

  @include media(">tablet", "<=1224px") {
    padding: $brand__boxspace--medium ($brand__boxspace--medium * 4) $brand__boxspace--medium
    ($brand__boxspace--medium * 4.5);
  }

  @include media(">1224px") {
    padding: $brand__boxspace--medium ($brand__boxspace--medium * 20) $brand__boxspace--medium
    ($brand__boxspace--medium * 20);
  }
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
      -ms-flex-direction: row;
          flex-direction: row;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  padding: $brand__boxspace--medium;
  background-color: $pv__color--grey;
  gap: $brand__boxspace--medium * 3;
  &__img{
    @include media("<=phone") {
      margin-left: ($brand__boxspace--medium * 1);
      width: $pv__dm__logo--phone;
      display: none;
    }

    @include media(">phone", "<=tablet") {
      margin-left: ($brand__boxspace--medium * 3);
      width: $pv__dm__logo--default;
      display: none;
    }

    @include media(">tablet", "<=1224px") {
      margin-left: ($brand__boxspace--medium * 4);
      width: $pv__dm__logo--default;
    }

    @include media(">1224px") {
      // margin-left: ($brand__boxspace--medium * 15);
      width: $pv__dm__logo--default;
    }
  }
  &__menu-container{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex:1;
        -ms-flex:1;
            flex:1;
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
    @include media("<=phone") {
      -webkit-box-pack: space-evenly;
          -ms-flex-pack: space-evenly;
              justify-content: space-evenly;
    }
    &__menu{
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      flex-wrap: wrap;
      gap: $brand__boxspace--medium;
      list-style: none;
      padding: 0;
      &__item{
        &__link{
          color: $pv__color--black-alter;
          font-family: "Open Sans",sans-serif;
          font-weight: 400;
          text-decoration: underline;
          &:focus{
            opacity: 1;
            outline-offset: $brand__boxspace--extrasmall;
            outline: $brand__boxspace--extrasmall solid $pv__color--black-alter;
          }
          &:hover{
            color: $pv__color--black-alter;
            opacity: 0.7;
            text-decoration: none;
          }
        }
      };
    }
  }
  &__text{
    color: $pv__color--darkgrey;
    font-style: italic;
    margin-right: ($brand__boxspace--medium * 5);
    text-align: right;
    @include media("<=phone") {
      margin-right: 1rem;
      display:none;
    }
  }
  a{
    font-size: 1rem;
  }
}
</style>
